import Vue from 'vue'
import request from '@/helpers/request'
import userTransformer from '@/helpers/userTransformer'
import snack from '@/helpers/snack'
function colorGenerator(val, maxVal) {
  function minMax(val, min, max) {
    let _val = val
    if (val < min) _val = min
    if (val > max) _val = max
    return _val
  }
  const maxcolor = 255
  const red = minMax(Math.round(maxcolor - (maxcolor / maxVal) * val), 0, maxcolor)
  const green = minMax(Math.round(0), 0, maxcolor)
  const blue = minMax(Math.round((maxcolor / maxVal) * val), 0, maxcolor)
  const opacity = 1
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`
}
export default {
  GET_SCHEDULE: ({ commit, state, rootGetters }, params) => {
    const unitId = params.unit_id
    const callback = params.callback
    const requestData = params

    delete requestData.unit_id
    delete requestData.callback

    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.schedules.all.replace('$1', unitId)}`,
      {
        params: requestData,
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Locale': navigator.language.substr(0, 2),
        },
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const result = userTransformer.transform(response.data.data, ['image'])
        commit('setSchedule', result)
      }
      if (_.isFunction(callback)) {
        callback()
      }
    })
  },
  SAVE_SCHEDULE: ({ commit, state, rootGetters }, params) => {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.schedules.store.replace('$1', params.employer_id)}`,
      {
        params: {
          schedules: params.data,
          unit_id: params.unit_id,
        },
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Locale': navigator.language.substr(0, 2),
        },
      },
      true,
    )
  },
  DELETE_SCHEDULE: ({ commit, state, rootGetters }, params) => {
    return request(
      'DELETE',
      `${Vue.config.server}/${Vue.config.modules.crm.api.schedules.delete.replace('$1', params.employer_id)}`,
      {
        params: {
          employerScheduleId: params.data,
          unit_id: params.unit_id,
        },
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Locale': navigator.language.substr(0, 2),
        },
      },
      true,
    )
  },
  APPROVE_SCHEDULE: ({ commit, state, rootGetters }, params) => {
    return request(
      'POST',
      `${Vue.config.server}/${Vue.config.modules.crm.api.schedules.approve}`,
      {
        params: {
          employer_schedule_ids: params,
        },
        headers: {
          'X-Timezone': rootGetters.timezone ? rootGetters.timezone : 'Europe/Moscow',
          'X-Requested-With': 'XMLHttpRequest',
          'X-Locale': navigator.language.substr(0, 2),
        },
      },
      true,
    )
  },
  GET_SCHEDULE_STATISTIC({ commit, state }, date) {
    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.stat.services}`,
      {
        params: {
          date,
        },
      },
      true,
    )
      .then(response => {
        if (response.data.result === 'success') {
          const data = response.data.data
          if (_.isEmpty(data)) {
            snack.add(Vue.config.localization.ru.errors.scheduleStatisticIsEmpty)
            return false
          }
          const max = _.max(_.map(data, item => item.count))
          const datasets = [
            {
              label: 'Загруженность',
              data: _.map(data, item => item.count),
              fill: false,
              borderColor: Vue.config.analyticColors[0],
              pointBorderColor: '#000',
              pointBackgroundColor: _.map(data, item => colorGenerator(item.count, max)),
            },
          ]
          const labels = _.map(data, item => `${item.hour} ч.`)
          commit('setScheduleStatistic', { datasets, labels })
          return true
        } else {
          throw response
        }
      })
      .catch(e => {
        console.info(e)
        snack.add(Vue.config.localization.ru.errors.scheduleStatistic)
        return false
      })
  },
}
